import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import Vue from "vue";

export default Vue.use(VueVideoPlayer);
